export default function Disaster() {
    return (
        <section className='relative w-full py-[150px]'>
            <img 
                src={`${process.env.REACT_APP_STATIC_URL}/images/main/Disaster_Section_Background.jpg`}
                alt="배경"
                className='absolute inset-0 w-full h-full z-[-2] object-cover object-center'
            />

            <div className='absolute inset-0 w-full h-full bg-black opacity-40 z-[-1]'/>

            <h2 className='text-center text-white text-title2 lg:text-display3 font-bold'>
                예기치 못한 재난 상황에서도<br/>
                링콜은 고객님의 위치를 파악해<br/>
                119에 빠르게 구조를 요청합니다.
            </h2>
        </section>
    )
}